import React from 'react';
import useRoute from '@/Hooks/useRoute';
import useTypedPage from '@/Hooks/useTypedPage';
import axios from 'axios';

export default function Logout({
  children,
  ...rest
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const route = useRoute();

  const { ziggy } = useTypedPage<{ ziggy: any }>().props;
  const appDomain = new URL(ziggy.url);

  function logout(e: React.FormEvent) {
    e.preventDefault();
    axios.post(route('logout')).then(() => {
      document.location.href = appDomain.href;
    });
  }

  return (
    <form onSubmit={logout} {...rest}>
      {children}
    </form>
  );
}
